import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { IBioSecurity } from '../../entities/task.entities';
import { defaultDateFormat } from '../../lib/common.helpers';
import { Button, CloseIcon, Input, Subtitle } from '../shared';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import FilesWall from '../shared/pictures-wall/FilesWall';
import { parseImageUrlToFileItem } from '../../lib/common.helpers';
import WeatherInfoModal from '../farm-modals/WeatherInfoModal';
import { useState } from 'react';
import weather_icon from '../../images/weather-icon.png';

interface Props {
  visible: boolean;
  biosecurity: IBioSecurity;
  onClose: () => void;
}

const BiosecurityViewModal = ({ visible, biosecurity, onClose }: Props) => {
  const lang = useSelector(selectLang);
  const [showWeather, setShowWeather] = useState(false);

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onClose}
        closable
        closeIcon={<CloseIcon />}
        width={600}
        footer={null}
      >
        <div className='wrap view-modal'>
          <div className='d-flex align-center mb-16'>
            <Subtitle color='black-1' align='left' size={1} fontWeight={600}>
              {translate(lang, 'Water Quality Details')}:
            </Subtitle>
            <Subtitle
              className='ml-7'
              color='black-3'
              align='left'
              size={1}
              fontWeight={500}
            >
              {`${biosecurity.farm.name} - ${biosecurity.line.line_name}`}
            </Subtitle>
          </div>
          <div className='pt-16 pb-24'>
            <div className='info-card'>
              <div className='info-label'>{translate(lang, 'Date')}</div>
              <div className='info-value'>
                {defaultDateFormat(biosecurity.report_date)}
              </div>
            </div>
            <div className='info-card'>
              <div className='info-label'>{translate(lang, 'Reporter')}</div>
              <div className='info-value'>{biosecurity.user?.name ?? '-'}</div>
            </div>
            {biosecurity.mussel_larvae && (
              <div className='info-card'>
                <div className='info-label'>
                  {translate(lang, 'Mussel larvae')}
                </div>
                <div className='info-value'>{biosecurity.mussel_larvae}</div>
              </div>
            )}
            {biosecurity.plankton && (
              <div className='info-card'>
                <div className='info-label'>{translate(lang, 'Plankton')}</div>
                <div className='info-value'>{biosecurity.plankton}</div>
              </div>
            )}
            {biosecurity.biofouling_larvae && (
              <div className='info-card'>
                <div className='info-label'>
                  {translate(lang, 'Biofouling larvae')}
                </div>
                <div className='info-value'>
                  {biosecurity.biofouling_larvae}
                </div>
              </div>
            )}
            {biosecurity.weather_condition && (
              <div className='info-card'>
                <div className='info-label'>{translate(lang, 'Weather')}</div>
                <div className='info-value'>
                  <img
                    src={weather_icon}
                    alt='weather'
                    className='weather-icon'
                    onClick={() => setShowWeather(true)}
                  />
                </div>
              </div>
            )}
            <div className='mt-7 mb-7'>
              <Input
                label={translate(lang, 'Comment')}
                type='textarea'
                value={biosecurity.comment ?? ''}
                disabled={true}
              />
            </div>
            {!!biosecurity.image_pdf_files &&
              biosecurity.image_pdf_files.length > 0 && (
                <div className='mt-7 mb-7'>
                  <FilesWall
                    label={translate(lang, 'Images & PDF Files')}
                    fileList={
                      biosecurity.image_pdf_files.map(x =>
                        parseImageUrlToFileItem(x),
                      ) as any
                    }
                    disabled={true}
                  />
                </div>
              )}
          </div>
        </div>
        <div className='modal-button d-flex justify-end align-center'>
          <Button
            width='small'
            size={2}
            type='fill'
            color='red'
            onClick={onClose}
          >
            {translate(lang, 'Close')}
          </Button>
        </div>
      </Modal>
      {showWeather && biosecurity.weather_condition && (
        <WeatherInfoModal
          visible={showWeather}
          onClose={() => setShowWeather(false)}
          data={biosecurity.weather_condition}
        />
      )}
    </>
  );
};

export default BiosecurityViewModal;
